import React from "react";
import { createRoot } from "react-dom/client";
import AppRoutes from "./helpers/AppRoutes";
import { registerServiceWorker } from "./helpers/ServiceWorkerUpdates";
import "./sass/styles.scss";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<AppRoutes />);

registerServiceWorker();
